import { BrowserRouter, Routes, Route } from "react-router-dom";
import Endpoint from "./components/Endpoints/Endpoint";
import SpecificEndpoint from "./components/Endpoints/SpecificEndpoint";
import Navbar from "./components/Navbar/Navbar";
import Login from "./components/Login/Login";
import "./App.css";
import ConfirmUserPage from "./components/Login/ConfirmUser";
import Performance from "./components/Performance/Performance";
import LogMonitor from "./components/LogMonitor/LogMonitor";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorPage from "./components/ErrorPage";
import GlobalConfiguration from "./components/GlobalConfiguration/GlobalConfiguration";
import SecurityPage from "./components/SecurityPage/SecurityPage";
import ResourceScheduler from "./components/ResourceScheduler/ResourceScheduler";
import CostManagement from "./components/CostManagement/CostManagement";
import UserManagementPage from "./components/UserManagementPage/UserManagementPage";
import ProfileSettings from "./components/ProfileSettings/ProfileSettings";
import ResetPassword from "./components/Login/ResetPassword";
import Home from "./components/Home/Home";
import SecurityLayout from "./components/SecurityPage/ApiCalls/SecurityLayoutComponent.jsx";
import S3Page from "./components/SecurityPage/ServicePages/S3Page.jsx";
import RDSPage from "./components/SecurityPage/ServicePages/RdsPage.jsx";
import ECSPage from "./components/SecurityPage/ServicePages/EcsPage.jsx";
import KMSPage from "./components/SecurityPage/ServicePages/KmsPage.jsx";
import LoginPage from "./components/SecurityPage/ServicePages/LoginPage.jsx";
import LoadBalancerPage from "./components/SecurityPage/ServicePages/LoadBalancerPage.jsx";
import EC2Page from "./components/SecurityPage/ServicePages/Ec2Page.jsx";
import WAFPage from "./components/SecurityPage/ServicePages/WafPage.jsx";
import SecurityConfig from "./components/GlobalConfiguration/Security/SecurityConfig";
import ResourceSchedulerConfig from "./components/GlobalConfiguration/ResourceScheduler/ResourceSchedulerConfig";
import EndpointConfig from "./components/GlobalConfiguration/Endpoint/EndpointConfig";
import CostConfig from "./components/GlobalConfiguration/CostManagement/CostConfig";
import PerformanceConfig from "./components/GlobalConfiguration/Performance/PerformanceConfig";
import LogMonitorConfig from "./components/GlobalConfiguration/LogMonitor/LogMonitorConfig";
import ReleaseConfig from "./components/GlobalConfiguration/ReleaseNotes/ReleaseConfig";
import CommonConfig from "./components/GlobalConfiguration/GlobalConfigIndex/CommonConfig.jsx";
import UnderDevelopmentPage from "./components/UnderDevelopment/UnderDevelopmentPage.jsx";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Login />} path="/login" />
        <Route element={<ConfirmUserPage />} path="/confirm" />
        <Route element={<ResetPassword />} path="/resetPassword" />
        <Route
          element={
            <ProtectedRoute>
              <Navbar />
            </ProtectedRoute>
          }
          path="/"
        >
          <Route index element={<Home />} />
          <Route path="endpoint" element={<Endpoint />} />
          <Route path="performance" element={<Performance />} />
          <Route
            path="log-monitor-in-progress"
            element={<UnderDevelopmentPage />}
          />
          <Route path="endpoint/:endpointName" element={<SpecificEndpoint />} />
          <Route path="logMonitor" element={<LogMonitor />} />
          <Route path="security" element={<SecurityLayout />}>
            <Route index element={<SecurityPage />} />
            <Route path="s3" element={<S3Page />} />
            <Route path="loginData" element={<LoginPage />} />
            <Route path="loadBalancer" element={<LoadBalancerPage />} />
            <Route path="ec2" element={<EC2Page />} />
            <Route path="rds" element={<RDSPage />} />
            <Route path="ecs" element={<ECSPage />} />
            <Route path="kms" element={<KMSPage />} />
            <Route path="waf" element={<WAFPage />} />
          </Route>
          <Route path="resourceScheduler" element={<ResourceScheduler />} />
          <Route path="cost" element={<CostManagement />} />
          <Route path="usermanagement" element={<UserManagementPage />} />
          <Route path="usersettings" element={<ProfileSettings />} />
          <Route path="config" element={<GlobalConfiguration />}>
            <Route index element={<CommonConfig />} />
            <Route path="performance" element={<PerformanceConfig />} />
            <Route path="security" element={<UnderDevelopmentPage />} />
            <Route path="logmonitor" element={<LogMonitorConfig />} />
            <Route path="security-under-dev" element={<SecurityConfig />} />
            <Route path="endpoint" element={<EndpointConfig />} />
            <Route path="release" element={<ReleaseConfig />} />
            <Route path="costManagement" element={<CostConfig />} />
            <Route
              path="resourceScheduler"
              element={<ResourceSchedulerConfig />}
            />
          </Route>
        </Route>

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}
